export default __webpack_public_path__ + "static/media/face_1_34.8759e862.png";